Object.defineProperty(exports, "__esModule", { value: true });
exports.InterfaceType = void 0;
const interfaceTypeRegistry_1 = require("./interfaceTypeRegistry");
const graphql_1 = require("graphql");
const Field_1 = require("../field/Field");
const cachedThunk_1 = require("../../services/utils/cachedThunk");
const inheritance_1 = require("../../services/utils/inheritance");
const registry_1 = require("../objectType/registry");
const compileInterfaceCache = new WeakMap();
function getInterfaceResolveType(target) {
    return (value) => {
        const implementors = interfaceTypeRegistry_1.interfaceTypeImplementors.get(target);
        if (Array.isArray(implementors)) {
            for (const implementor of implementors) {
                if (Object.getPrototypeOf(value) === implementor.prototype) {
                    const typeGetterFromRegistry = registry_1.objectTypeRegistry.get(implementor);
                    return typeGetterFromRegistry();
                }
            }
        }
    };
}
function getFieldsGetter(target, config) {
    return cachedThunk_1.createCachedThunk(() => {
        let targetWithParents = inheritance_1.getClassWithAllParentClasses(target);
        if (config) {
            const { mixins } = config;
            if (typeof mixins === 'function') {
                targetWithParents = targetWithParents.concat(mixins());
            }
            else if (Array.isArray(mixins)) {
                targetWithParents = targetWithParents.concat(mixins);
            }
        }
        return Field_1.compileAllFields(targetWithParents);
    });
}
function InterfaceType(config) {
    return (target) => {
        interfaceTypeRegistry_1.interfaceClassesSet.add(target);
        const typeGetter = () => {
            if (compileInterfaceCache.has(target)) {
                return compileInterfaceCache.get(target);
            }
            const name = config && config.name ? config.name : target.name;
            const description = config ? config.description : null;
            const intfc = new graphql_1.GraphQLInterfaceType({
                name,
                description,
                resolveType: getInterfaceResolveType(target),
                fields: getFieldsGetter(target, config)
            });
            compileInterfaceCache.set(target, intfc);
            return intfc;
        };
        interfaceTypeRegistry_1.interfaceTypeRegistry.set(target, typeGetter);
    };
}
exports.InterfaceType = InterfaceType;
//# sourceMappingURL=InterfaceType.js.map